// src/components/shared/ToastStack.js
import React from 'react';
import { useApp } from '../../lib/AppContext';

const ICONS = { success: '✅', error: '❌', warning: '⚠️', info: 'ℹ️' };

export default function ToastStack() {
  const { toasts, dispatch } = useApp();
  if (!toasts.length) return null;
  return (
    <div className="toast-stack">
      {toasts.map(toast => (
        <div key={toast.id} className={`toast ${toast.type || 'info'}`}>
          <span style={{ fontSize: '1rem', flexShrink: 0 }}>{ICONS[toast.type] || 'ℹ️'}</span>
          <span style={{ flex: 1, fontSize: '.85rem' }}>{toast.message}</span>
          <button
            onClick={() => dispatch({ type: 'REMOVE_TOAST', payload: toast.id })}
            style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '1rem', flexShrink: 0 }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
